module.exports = __webpack_public_path__ + "img/close.13db3845.svg";